import { configureStore } from '@reduxjs/toolkit';
import organizationReducer from 'slices/organization-slice';

export const store = configureStore({
  reducer: {
    organization: organizationReducer,
  },
});